export default __webpack_public_path__ + "static/media/katya.74286270.jpg";